import { LiveQueryProvider } from '@sanity/preview-kit'
import { type ReactNode, useMemo } from 'react'

import { getPreviewSanityClient } from './client'

interface PreviewProviderProps {
  token: string
  children: ReactNode
}

const PreviewProvider = ({ token, children }: PreviewProviderProps) => {
  const previewSanityClient = useMemo(() => {
    return getPreviewSanityClient(token)
  }, [token])

  return (
    <LiveQueryProvider client={previewSanityClient}>
      {children}
    </LiveQueryProvider>
  )
}

export default PreviewProvider
